import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import {
  MissionForm,
  MissionFormSubmitHelpers,
} from "../../components/MissionForm";
import { useMission } from "../../hooks/useMission";
import { useParams } from "react-router-dom";
import { useUpdateMission } from "../../hooks/useUpdateMission";
import { MissionSchema } from "../../schemas/mission.schema";
import { useGoBack } from "@/common/hooks/useGoBack";

const MissionsEdit = () => {
  const { id } = useParams<{ id: string }>();
  const goBack = useGoBack();

  const { data: mission, isLoading, error, refetch } = useMission(id);

  const { mutate: updateMission, isPending } = useUpdateMission({
    onSuccess: () => goBack({ fallback: "/tmais-missions" }),
  });

  const handleSubmit = (
    values: MissionSchema,
    helpers: MissionFormSubmitHelpers,
  ) => {
    if (!id) return;
    updateMission({ id, form: values }, { onError: helpers.onError });
  };

  if (isLoading) {
    return (
      <ErrorMessageWrapper className="h-[calc(100vh-100px)]" statusCode={200}>
        <div className="flex h-full items-center justify-center text-gray-400">
          Carregando...
        </div>
      </ErrorMessageWrapper>
    );
  }

  return (
    <ErrorMessageWrapper
      statusCode={(error as any)?.status || (mission ? 200 : 404)}
      refetchFunction={refetch}
      notFoundFallback="Missão não encontrada"
      notFoundHideButton
    >
      {mission && (
        <div className="flex flex-col h-[calc(100vh-100px)]">
          <div className="flex-1 overflow-y-auto pr-4 pb-10">
            <MissionForm
              mode="edit"
              initialValues={mission}
              onSubmit={handleSubmit}
              isSubmitting={isPending}
              onCancel={() => goBack({ fallback: "/tmais-missions" })}
            />
          </div>
        </div>
      )}
    </ErrorMessageWrapper>
  );
};

export default MissionsEdit;
